var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"iAScpkIxdvWYfzdKAIbPp"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the intialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const SENTRY_ENVIRONMENT =
  process.env.SENTRY_ENVIRONMENT || process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT;
const SENTRY_SAMPLERATE =
  process.env.SENTRY_SAMPLERATE || process.env.NEXT_PUBLIC_SENTRY_SAMPLERATE;
const SENTRY_TRACESSAMPLERATE =
  process.env.SENTRY_TRACESSAMPLERATE ||
  process.env.NEXT_PUBLIC_SENTRY_TRACESSAMPLERATE;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    sampleRate: SENTRY_SAMPLERATE,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: (samplingContext) => {
      if (samplingContext.transactionContext.name === "GET /api/health-check") {
        return 0;
      }
      return SENTRY_TRACESSAMPLERATE;
    },
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
  });
}
